var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{attrs:{"light":"","type":"secondary","bar":"","icon":['fad', !!this.$root.sidebarHidden ? 'arrow-to-left' : 'arrow-to-right'],"action":_vm.toogleSidebar}})}
var staticRenderFns = []

export { render, staticRenderFns }